module.exports = __webpack_public_path__ + "static/media/tack3.c96e7a70.png";